// components/BottomNav.tsx
import { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styled, { useTheme } from "styled-components";
import { routeList } from "../App";
import { usePwaViewportWidth } from "../hooks/useScreenWidth";
import { hasConvNewMessage } from "../pages/Chat.page";
import api from "../services/api";
import { useUserStore } from "../store/useUserStore";
import { BookIcon } from "./svgs/icons/Book.icon";
import { ChatIcon } from "./svgs/icons/Chat.icon";
import { DogFaceIcon } from "./svgs/icons/DogFaceIcon.icon";

export const BottomNavBar = () => {
  const theme = useTheme();
  const screenWidth = usePwaViewportWidth();
  const location = useLocation();
  const {
    profile: { _id },
    nbConvWithNewMessage,
    setNbConvWithNewMessage,
  } = useUserStore();

  const getColorFromActivity = (route: string) =>
    location.pathname.startsWith(route) ? theme.color.tertiaryLight : theme.color.primaryDark;

  useEffect(() => {
    (async function getChats() {
      try {
        const response = await api.getChats();
        const nbConvWithNewMessage = response.data.chats.filter((e) => hasConvNewMessage(e, _id)).length;
        setNbConvWithNewMessage(nbConvWithNewMessage);
      } catch (err) {
        console.log("Error fetching chats", err);
        alert("Error fetching chats");
      }
    })();
  }, []);

  return (
    <RootContainer $width={screenWidth}>
      <NavItem to={routeList.swiper}>
        <DogFaceIcon color={getColorFromActivity(routeList.swiper)} />
      </NavItem>
      <NavItem to={routeList.informations}>
        <BookIcon color={getColorFromActivity(routeList.informations)} />
      </NavItem>
      <NavItem to={routeList.chat}>
        <ChatIcon color={getColorFromActivity(routeList.chat)} />
        {nbConvWithNewMessage > 0 && <RedBubble>{nbConvWithNewMessage}</RedBubble>}
      </NavItem>
    </RootContainer>
  );
};

const RootContainer = styled.nav<{
  $width: number;
}>`
  width: ${(props) => props.$width}px;
  display: flex;
  justify-content: center;
  padding: 1rem;
  gap: 0 1rem;
`;

const NavItem = styled(NavLink)`
  position: relative;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 5rem;
  aspect-ratio: 1;
  border-radius: 1.5rem;
  background: ${(props) => props.theme.color.primaryLight};
  border: ${(props) => `4px solid ${props.theme.color.primaryDark}`};

  &.active {
    background: ${(props) => props.theme.color.primary};
    border-color: ${(props) => props.theme.color.tertiaryLight};
    font-weight: bold;
  }

  > svg {
    height: 100%;
  }
`;

const RedBubble = styled.div`
  border-radius: 100px;
  background: ${(props) => props.theme.color.tertiary};
  color: ${(props) => props.theme.color.tertiaryLight};
  position: absolute;
  top: 0;
  right: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(50%, -50%);
  font-family: ${(props) => props.theme.font.family.label};
`;
